export default __webpack_public_path__ + "static/media/meeting.6bb10c93.svg";